import { clearUser, setStylistInfo, setDistributorInfo, setUser } from "@/store/slices/authSlice";
import ls from "../SecureLS";

export const initializeAuthFromLocalStorage = (dispatch: any) => {
  const userLs = ls.get("user") || "";
  const userInfo = JSON.parse(userLs || "{}");

  const stylistInfoLs = ls.get("stylistInfo") || "";
  const distributorInfoLs = ls.get("distributorInfo") || "";

  if (userInfo) {
    try {
      if (userInfo?.email) {
        dispatch(setUser(userInfo));
      }

      if (userInfo?.current_role === "stylist") {
        dispatch(setStylistInfo(JSON.parse(stylistInfoLs || "{}")));
      }
      if (userInfo?.current_role === "distributor") {
        dispatch(setDistributorInfo(JSON.parse(distributorInfoLs || "{}")));
      }
    } catch (error) {
      console.error("Failed to set user:", error);

      dispatch(clearUser());
    }
  } else {
    dispatch(clearUser());
  }
};
